//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "../../api/common";
export default {
    data() {
        return {
            
        }
    },
    // 生命周期之挂载完成
    methods: {
       //获取订单详情
        getOrderDetails(){
            let params = {
                /*是否获取医生详情信息 1 获取2 不获取*/
                getDoctor: '1',
                /*是否获取患者详情信息 1 获取2 不获取*/
                getPatient: '1',
                /*是否获取主诉  1 获取2 不获取*/
                isaction: '1',
                /*是否获取此订单的药方订单详细信息 1 获取2 不获取*/
                getPrescriptionOrder: '1',
                /*药方订单id，如果想获取问诊订单下面的所有药方订单，此处可不传*/
                prescriptionOrderId: this.orederId,
            }


            this.$doRequest("/api/Inquiry/orderDetails", params, res=>{
                this.doctor = res.doctor;//医生信息
                this.patient = res.patient;//患者信息
                this.orderinfo = res.orderprescriptioninfos[0];//订单信息（药方订单信息）
                if (this.orderinfo.paystate == 1 && this.orderinfo.orderstate != 4) {
                    this.time(this.orderinfo.servicetime,this.orderinfo.buytime);
                }
                this.orderCode = this.orderinfo.orderid;//支付的时候用
                this.resultBuyTime = common.timestampToTime(this.orderinfo.buytime)//下单时间
                this.resultTime = common.timestampToTime(this.orderinfo.paytime);//支付时间

                //非支付状态下收件人
                if(this.orderinfo.paystate != 1){
                    let eq = this.orderinfo.address.indexOf('$');
                    let total = this.orderinfo.address.length;
                    this.overaddress = this.orderinfo.address.substring(0,eq);
                    this.overname = this.orderinfo.address.substring(eq+1,total);
                }

                if(this.isSelect){
                    //选择后的优惠券以选择的为准
                    this.couponId = this.$route.query.couponId;
                    this.couponSum = this.$route.query.couponSum;
                }else{
                    if(this.orderinfo.orderstate == 1){
                        this.getCoupon();
                    }else if(this.orderinfo.orderstate == 2){
                        if(this.orderinfo.saletype == 2){
                            this.couponId = this.orderinfo.couponid;
                            this.couponSum = this.orderinfo.saleprice;
                        }
                    }
                }
            })
        },

    },
    //生命周期之创建完成
    created: function(){
        this.$isLogin(window.location.search.substr(1),this.init);
        document.title = '订单详情';
    },
}



// WEBPACK FOOTER //
// ./src/views/orderDetailsYF/index.vue